import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';

interface StylesProps {
  mt: any
  mb: any
}

export default makeStyles<NextTheme>((theme) =>
  createStyles({
    root: ({ mt, mb }: StylesProps) => ({
      marginTop: theme.spacing(mt),
      marginBottom: theme.spacing(mb),
    }),
    inlineStyle: {
      display: 'inline-block',
      width: 'calc(33.333% - 12px)',
      marginRight: theme.spacing(1.5),
    },
  }),
);
